import React, { Component } from 'react'
import './Product_content.css'
import Product_review from '../Product_review/Product_review'
import Product_size_table from '../Product_size_table/Product_size_table'

export default class Product_content extends Component {
  render() {
    const {ProductData} = this.props
    return (
      <div className='Product_content'>
        <div className='Product_content_section'>
          
          <div className="row">
            {ProductData.comodin_landing_content.map(content=>
              <div>
                {
                  content.img_src.is_video?
                  <Product_content_video src={content.img_src.file_src} />
                  :
                  <Product_content_img imgSrc={content.img_src.file_src}/>
                }
                <Product_content_main_text mainText={content.main_text} />
                <Product_content_subtext subText={content.sub_text} />
              </div>
            )}
          </div>
          <div className="">
            <Product_size_table ProductData={ProductData}/>
          </div>
          <div  className="row">
            <Product_review ProductData={ProductData}/>
          </div>
        </div>
      </div>
    )
  }
}



class Product_content_img extends Component {
  render() {
    const {imgSrc} = this.props
    return (
      <div className="Product_content_img col-12 d-flex justify-content-center">
        <img src={imgSrc} alt="" fetchpriority={"high"} loading="lazy"/>
      </div>
    )
  }
}

class Product_content_video extends Component {
  render() {
    const {src} = this.props
    return (
      <div className="Product_content_img col-12 d-flex justify-content-center">
        <video style={{maxWidth:"100%"}} preload="none" loop muted controls={false} autoPlay src={src} playsInline/>
      </div>
    )
  }
}


class Product_content_main_text extends Component {
  render() {
    const {mainText} = this.props
    return (
      <div className='Product_content_main_text col-12 d-flex justify-content-center'>
        {mainText}
      </div>
    )
  }
}

class Product_content_subtext extends Component {
  render() {
    const {subText} = this.props
    return (
      <div className='Product_content_subtext col-12 d-flex justify-content-center'>
        {subText}
      </div>
    )
  }
}



